import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AccountInfoActions } from '../../../account-info-header/actions';
import { ServiceError } from '../../../create-request/models/shared/ServiceError';
import { Subject, filter, takeUntil } from 'rxjs';
import { selectFilePickerModalActive, selectFilePickerModalContent } from '../../reducers';
import { FileReaderService } from '../../services/file-reader.service';
import { StatusViewResponse } from '../../models/StatusViewResponse';
import { createInstructionFromOverviewSloa, mapApiResponseToOverview } from '../../../create-request/effects/create-request.effects';
import { mapApiResponsetoAccountInfo } from '../../../account-info-header/effects/account-info.effects';
import { AccountInfoApiResponse } from '../../../account-info-header/models/AccountInfoApiResponse';
import { ToastrService } from 'ngx-toastr';

@Component({
  standalone: false,
  selector: 'mm-file-picker-modal',
  templateUrl: './file-picker-modal.component.html',
  styleUrls: ['./file-picker-modal.component.scss']
})
export class FilePickerModalComponent {
  callName: string;
  modalId: string;
  destroy$: Subject<boolean> = new Subject<boolean>();
  modal: EverestModal;
  continueClicked: boolean = false;
  failedCall: string;
  error: ServiceError = {
    error: {
      error: '',
      errorDescription: ''
    },
    headers: {
      normalizedNames: '',
      lazyUpdate: ''
    },
    status: 500,
    statusText: 'call failed',
    url: '',
    ok: false,
    name: '',
    message: '',
    loading: false
  }

  constructor(private store: Store, private fileReaderService: FileReaderService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.store
      .select(selectFilePickerModalActive)
      .pipe(takeUntil(this.destroy$))
      .subscribe((show) => {
        this.modal = document.getElementById('file-picker-modal') as EverestModal;
        this.continueClicked = false;
        if (show) this.modal.showModal();
      });

      this.store
      .select(selectFilePickerModalContent)
      .pipe(
        takeUntil(this.destroy$),
        filter((content) => content ? content.length > 0 : false)
      )
      .subscribe((content) => {
        if (content) {
          this.toastr.error(`${content} has failed.`);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  onCancelClick(): void {
      this.modal.hideModal();
  }

  async onUploadOverviewClick(): Promise<void> {
    let result = await this.fileReaderService.getFile() as StatusViewResponse;
    let standingInstructions = result.cashieringSloas.map((sloa) => {
      return createInstructionFromOverviewSloa(sloa, result.isIip)
    });
    this.store.dispatch(AccountInfoActions.loadTransactionsSuccess(mapApiResponseToOverview(result, standingInstructions, '')));
  }

  async onUploadAccountClick(): Promise<void> {
    let result = await this.fileReaderService.getFile();
    const accountInfoSaveFile = mapApiResponsetoAccountInfo(result as AccountInfoApiResponse)
    this.store.dispatch(AccountInfoActions.loadAccountInfoSuccess(accountInfoSaveFile));
  }
}

type EverestModal = HTMLElement & {
  showModal: () => {};
  hideModal: () => {};
};
